import { Link } from "react-router-dom";

import { buildJobDetailsHref, getJobIdFromValues } from "../jobListNavigation";

const JobIdLink = ({ values }) => {
  const jobId = getJobIdFromValues(values);
  if (!jobId) return null;

  return (
    <Link
      className="font-medium text-black underline hover:text-gray-500"
      to={buildJobDetailsHref({
        jobId,
        search: window.location.search,
      })}
    >
      {jobId}
    </Link>
  );
};

export default JobIdLink;
